import { useEffect } from 'react';

/**
 * Custom hook to scroll to top of page on mount
 * Fixes iOS physical device scroll position issues
 */
const useScrollToTop = () => {
  useEffect(() => {
    // Multiple methods to ensure scroll to top works on all devices
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Delay for iOS rendering
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 0);
  }, []);
};

export default useScrollToTop;
